import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  width: 50%;
`;

export const Category = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
